import { render, staticRenderFns } from "./PhaseBanner.vue?vue&type=template&id=7a30295e&scoped=true"
import script from "./PhaseBanner.vue?vue&type=script&lang=js"
export * from "./PhaseBanner.vue?vue&type=script&lang=js"
import style0 from "./PhaseBanner.vue?vue&type=style&index=0&id=7a30295e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a30295e",
  null
  
)

export default component.exports